import { c as _c } from "react/compiler-runtime";
import { COUNTRIES_DATA } from '@/lib/constants/countries';
import { useQuery } from '@tanstack/react-query';
export const FALLBACK_COUNTRY_CODE = 'US';
const USER_COUNTRY_KEY = 'userCountryCode';
const isValidNonEmptyCountryCode = code => COUNTRIES_DATA.some(c => c.code === code && c.code !== 'NONE');
const fetchUserCountryCode = async () => {
  const cachedCountryCode = localStorage.getItem(USER_COUNTRY_KEY);
  if (cachedCountryCode && isValidNonEmptyCountryCode(cachedCountryCode)) {
    return cachedCountryCode;
  }
  try {
    const response = await fetch('https://ipwho.is/');
    if (!response.ok) {
      console.error(`Network response was not ok for ipwho.is. Status: ${response.status}`);
      return FALLBACK_COUNTRY_CODE;
    }
    const data = await response.json();
    const apiCountryCode = data.country_code;
    if (typeof apiCountryCode === 'string' && isValidNonEmptyCountryCode(apiCountryCode)) {
      localStorage.setItem(USER_COUNTRY_KEY, apiCountryCode);
      return apiCountryCode;
    }
    console.warn('ipwho.is did not return a valid or known country code:', apiCountryCode);
    return FALLBACK_COUNTRY_CODE;
  } catch (error) {
    console.error('Failed to fetch country from ipwho.is:', error);
    return FALLBACK_COUNTRY_CODE;
  }
};
export const useUserCountryQuery = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: [USER_COUNTRY_KEY],
      queryFn: fetchUserCountryCode,
      staleTime: Infinity,
      gcTime: Infinity
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};